// extracted by mini-css-extract-plugin
export var menuIcon = "_r9-0";
export var menuIconInline = "_r9-1";